"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationForm = IntegrationForm;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var content_dialog_1 = require("../../../features/thunks/content-dialog");
var save_shortcut_1 = require("../../../features/save-shortcut/save-shortcut");
var hooks_1 = require("../../../store/hooks");
function IntegrationForm(props) {
    var _this = this;
    var onSubmit = props.onSubmit, initialData = props.initialData, defaults = props.defaults;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var _a = (0, react_3.useState)({
        baseUrl: (initialData === null || initialData === void 0 ? void 0 : initialData.baseUrl) || (defaults === null || defaults === void 0 ? void 0 : defaults.baseUrl) || "",
        protocol: (initialData === null || initialData === void 0 ? void 0 : initialData.protocol) || (defaults === null || defaults === void 0 ? void 0 : defaults.protocol) || "",
        action: (initialData === null || initialData === void 0 ? void 0 : initialData.action) || (defaults === null || defaults === void 0 ? void 0 : defaults.action) || "",
        email: (initialData === null || initialData === void 0 ? void 0 : initialData.email) || "",
        password: (initialData === null || initialData === void 0 ? void 0 : initialData.password) || "",
    }), formData = _a[0], setFormData = _a[1];
    var _b = (0, react_3.useState)(new Set()), errors = _b[0], setErrors = _b[1];
    var _c = (0, react_3.useState)(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var handleInputChange = function (field, value) {
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
        setErrors(function (prev) {
            var next = new Set(prev);
            next.delete(field);
            return next;
        });
    };
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var newErrors, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newErrors = new Set();
                    if (!formData.baseUrl.trim())
                        newErrors.add("baseUrl");
                    if (!formData.protocol.trim())
                        newErrors.add("protocol");
                    if (!formData.action.trim())
                        newErrors.add("action");
                    if (!formData.email.trim())
                        newErrors.add("email");
                    if (!formData.password.trim())
                        newErrors.add("password");
                    if (newErrors.size > 0) {
                        setErrors(newErrors);
                        (0, react_1.addToast)({
                            title: "Validation Failed",
                            description: "Please fill in all required fields highlighted in red.",
                            color: "danger",
                        });
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    return [4 /*yield*/, onSubmit(formData)];
                case 1:
                    success = _a.sent();
                    setIsSubmitting(false);
                    if (success) {
                        dispatch((0, content_dialog_1.closeContentDialogThunk)());
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // ATOC-1 C2.g: "on any screen of Cue where fields could be changed".
    (0, save_shortcut_1.useSaveShortcut)({ label: "Integration", handler: handleSubmit });
    var handleCancel = function () {
        dispatch((0, content_dialog_1.closeContentDialogThunk)());
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6 p-6", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("h3", { className: "mb-3 flex items-center gap-2 text-sm font-semibold text-gray-700", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:server-linear", className: "text-lg" }), "Connection Settings"] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Base URL", placeholder: "e.g. https://api.example.com", value: formData.baseUrl, onValueChange: function (v) { return handleInputChange("baseUrl", v); }, variant: "bordered", isRequired: true, isInvalid: errors.has("baseUrl"), startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:link-linear", className: "text-gray-400" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-2 gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Protocol", placeholder: "e.g. https", value: formData.protocol, onValueChange: function (v) { return handleInputChange("protocol", v); }, variant: "bordered", isRequired: true, isReadOnly: !!defaults, isInvalid: errors.has("protocol"), startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:lock-linear", className: "text-gray-400" }) }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Action", placeholder: "e.g. sync", value: formData.action, onValueChange: function (v) { return handleInputChange("action", v); }, variant: "bordered", isRequired: true, isReadOnly: !!defaults, isInvalid: errors.has("action"), startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:lock-linear", className: "text-gray-400" }) })] })] })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("h3", { className: "mb-3 flex items-center gap-2 text-sm font-semibold text-gray-700", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:lock-keyhole-linear", className: "text-lg" }), "Authentication"] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Email", placeholder: "e.g. admin@example.com", value: formData.email, onValueChange: function (v) { return handleInputChange("email", v); }, variant: "bordered", isRequired: true, isInvalid: errors.has("email") }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "password", label: "Password", placeholder: "Enter password", value: formData.password, onValueChange: function (v) { return handleInputChange("password", v); }, variant: "bordered", isRequired: true, isInvalid: errors.has("password") })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2 border-t border-gray-100 pt-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: handleCancel, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", onPress: handleSubmit, isLoading: isSubmitting, startContent: !isSubmitting ? (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:check-circle-linear", className: "text-lg" }) : undefined, children: "Save Configuration" })] })] }) }));
}
